var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowForward({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#7292F7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 12.5925H16.17L11.29 17.4725C10.9 17.8625 10.9 18.5025 11.29 18.8925C11.68 19.2825 12.31 19.2825 12.7 18.8925L19.29 12.3025C19.68 11.9125 19.68 11.2825 19.29 10.8925L12.71 4.2925C12.32 3.9025 11.69 3.9025 11.3 4.2925C10.91 4.6825 10.91 5.3125 11.3 5.7025L16.17 10.5925H5C4.45 10.5925 4 11.0425 4 11.5925C4 12.1425 4.45 12.5925 5 12.5925Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForward);
export default __webpack_public_path__ + "static/media/arrow_forward.9716501b3b795d4eba76e58103654994.svg";
export { ForwardRef as ReactComponent };